import type { ReviewRowModel } from '@seek/libs-shared';
import { useConfig } from '@seek/libs-shared';
import { Helmet } from 'react-helmet';
import type { AppConfig } from '../../../shared/config';
import { mapToJsonLd } from './mapper';

export interface SeoStructuredData {
  name: string;
  ratingCount: number;
  ratingValue: number;
  bestRating?: number;
  isSalariesTab?: boolean;
  language?: string;
  location?: string;
  logo?: string;
  ratingExplanation?: string;
  reviews?: ReviewRowModel[];
  url?: string;
  worstRating?: number;
}

interface SeoStructuredDataProps {
  data?: SeoStructuredData;
}

export const SeoStructuredData = ({ data }: SeoStructuredDataProps) => {
  const { absoluteUrl, language } = useConfig<AppConfig>();

  if (!data) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(
          mapToJsonLd({ ...data, url: data.url || absoluteUrl, language }),
        )}
      </script>
    </Helmet>
  );
};
